import { getApps, initializeApp } from "firebase/app";

import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { initializeAuth, browserLocalPersistence } from "firebase/auth";
//import { getRemoteConfig, fetchAndActivate } from "firebase/remote-config";

export const ADMIN_ENV_STORAGE_KEY = "scerv-admin-environment";

// Testing is opt-in at build time; never borrow credentials/config from another lane.
const testingFirebaseConfig = (() => {
	try {
		const value = JSON.parse(process.env.REACT_APP_TESTING_FIREBASE_CONFIG || "null");
		return value?.projectId === "scervmvp-testing" && value.apiKey && value.appId && value.authDomain ? value : null;
	} catch { return null; }
})();

const ALL_ADMIN_ENVIRONMENTS = {
	...(testingFirebaseConfig ? { testing: {
		key: "testing", label: "Testing", shortLabel: "TEST", projectId: "scervmvp-testing", tone: "dev",
		description: "Isolated hardening acceptance environment.", firebaseConfig: testingFirebaseConfig,
	} } : {}),
	dev: {
		key: "dev",
		label: "QA",
		shortLabel: "QA",
		projectId: "scervmvp-dev",
		tone: "dev",
		description: "QA acceptance environment (scervmvp-dev).",
		firebaseConfig: {
			apiKey: "AIzaSyBlejZVzTAdevMwT8T5Vhl7yYNQ4BIwD9U",
			authDomain: "scervmvp-dev.firebaseapp.com",
			projectId: "scervmvp-dev",
			storageBucket: "scervmvp-dev.firebasestorage.app",
			messagingSenderId: "464887665401",
			appId: "1:464887665401:web:208fbf2c5c7163e1480828",
		},
	},
	production: {
		key: "production",
		label: "Production",
		shortLabel: "PROD",
		projectId: "scervmvp",
		tone: "production",
		description: "Live Scerv data. Changes affect real operational records.",
		firebaseConfig: {
			apiKey: "AIzaSyB4Bi4Ql9nqG73nCzlJ_mv8WNQHKB0ugVI",
			authDomain: "scervmvp.firebaseapp.com",
			projectId: "scervmvp",
			storageBucket: "scervmvp.appspot.com",
			messagingSenderId: "606076519772",
			appId: "1:606076519772:web:cd28a806d4cfae324a2d99",
			measurementId: "G-PD1WJ2X732",
		},
	},
};

const testingOnly = process.env.REACT_APP_TESTING_PORTAL === "true";
const qaOnly = process.env.REACT_APP_QA_PORTAL === "true";
if (testingOnly && qaOnly) throw new Error("QA and Testing portal flags cannot both be enabled.");
if (testingOnly && !testingFirebaseConfig) throw new Error("Testing portal requires testing Firebase configuration.");
export const ADMIN_ENVIRONMENTS = testingOnly ? { testing: ALL_ADMIN_ENVIRONMENTS.testing } : qaOnly ? {
	dev: ALL_ADMIN_ENVIRONMENTS.dev,
} : ALL_ADMIN_ENVIRONMENTS;

export const getSelectedAdminEnvironmentKey = () => {
	if (testingOnly) return "testing";
	if (qaOnly) return "dev";
	if (typeof window === "undefined") return "dev";
	const storedKey = window.localStorage.getItem(ADMIN_ENV_STORAGE_KEY);
	return Object.prototype.hasOwnProperty.call(ADMIN_ENVIRONMENTS, storedKey) ? storedKey : "dev";
};

export const selectedAdminEnvironmentKey = getSelectedAdminEnvironmentKey();
export const selectedAdminEnvironment =
	ADMIN_ENVIRONMENTS[selectedAdminEnvironmentKey];

export const switchAdminEnvironment = (nextEnvironmentKey) => {
	if (!Object.prototype.hasOwnProperty.call(ADMIN_ENVIRONMENTS, nextEnvironmentKey)) return;
	window.localStorage.setItem(ADMIN_ENV_STORAGE_KEY, nextEnvironmentKey);
	window.location.assign("/signin");
};

// Validate both the bundled config and any reused app before accessing services.
if (!selectedAdminEnvironment.projectId || selectedAdminEnvironment.firebaseConfig?.projectId !== selectedAdminEnvironment.projectId) {
	throw new Error(`${selectedAdminEnvironment.label} portal requires the ${selectedAdminEnvironment.projectId} Firebase configuration.`);
}
const app = getApps()[0] || initializeApp(selectedAdminEnvironment.firebaseConfig);
if (app?.options?.projectId !== selectedAdminEnvironment.projectId) {
	throw new Error(`${selectedAdminEnvironment.label} portal requires the ${selectedAdminEnvironment.projectId} Firebase app.`);
}

export const db = getFirestore(app);
export const auth = initializeAuth(app, {
	persistence: browserLocalPersistence,
});

export const functions = getFunctions(app);

export default app;
